import { render, staticRenderFns } from "./the-side-menu.vue?vue&type=template&id=68f540aa&scoped=true&"
import script from "./the-side-menu.vue?vue&type=script&lang=ts&"
export * from "./the-side-menu.vue?vue&type=script&lang=ts&"
import style0 from "./the-side-menu.vue?vue&type=style&index=0&id=68f540aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f540aa",
  null
  
)

export default component.exports